import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import * as Sentry from '@sentry/react';
import GA_MEASUREMENT_ID from './config/analytics';
import ReactGA from 'react-ga4';

import debug from 'helpers/debug';
debug('Init App');

Sentry.init({ environment: "DEV",  release: "20260407.2",
  dsn: "https://bd9620ea4d4d38e2337f7297e0f1dd2e@o4507662988935168.ingest.us.sentry.io/4507662990835712",
  integrations: [
    Sentry.replayIntegration(),
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
ReactGA.initialize(GA_MEASUREMENT_ID, {debug_mode: true});

// Google tag (gtag.js)
const loadGoogleAnalytics = () => {
  const script1 = document.createElement("script");
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script1.async = true;
  document.head.appendChild(script1);

  const script2 = document.createElement("script");
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_MEASUREMENT_ID}', {
      send_page_view: false
    });
  `;
  document.head.appendChild(script2);
};

loadGoogleAnalytics();

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

serviceWorker.unregister();
